<template>
    <div class="mtg-agents-block__body">
        <div class="mtg-agents-block__head g-text__p _gray g_semibold">Документы</div>
        <div v-if="data.data && data.data.items" class="mtg-agents-block__docs">
            <a
                v-for="(doc, idx) in data.data.items"
                :key="`doc-${idx}`"
                class="mtg-agents-block__doc u-link__download"
                :href="doc.props.file.src"
                target="_blank"
            >
                <span class="u-link__download-text g_medium">{{ doc.name }}</span>
            </a>
        </div>
        <div></div>
    </div>
</template>

<script>
export default {
    name: 'MortAgentsDocsWithTabs',
    props: {
        data: {
            type: Object,
            default () {
                return [];
            }
        }
    },
    mounted() {
        console.log('m', this.data);
    }
};
</script>
